export enum PARTNER_USER_STATUS {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
}

export enum PARTNER_USER_ROLE {
  ADMIN = 'ROLE_PARTNER_ADMIN',
  USER = 'ROLE_PARTNER_USER',
}

export enum PARTNER_USER_ACTION {
  EDIT = 'edit',
  CHANGE_ROLE = 'change-role',
  SET_PASSWORD = 'set-password',
  DELETE = 'delete',
}

export type PartnerUsersScope = { partnerId: string } | { ownPartner: true };

export interface PartnerRole {
  id: string;
  name: PARTNER_USER_ROLE;
}

export interface PartnerUserResponse {
  id: string;
  first_name: string;
  last_name: string | null;
  email: string;
  phone_number: string | null;
  language: string;
  status: PARTNER_USER_STATUS;
  roles: { id: string; name: string }[];
  created_at: string;
  updated_at: string;
}

export interface PartnerUser {
  id: string;
  full_name: string;
  first_name: string;
  last_name: string | null;
  email: string;
  phone_number: string | null;
  role: PARTNER_USER_ROLE;
  status: PARTNER_USER_STATUS;
  created_at: string;
}

export interface PartnerUserCreateRequest {
  first_name: string;
  last_name?: string;
  email: string;
  phone_number?: string;
  credentials: { password: string };
  roles?: string[];
}

export interface PartnerUserUpdateRequest {
  first_name: string;
  last_name: string | null;
  email: string;
  phone_number: string | null;
}
